<template>
    <div v-if="typeBar == 'progress'" class="progress">
        <ProgressBar :status="approved" />
        <ProgressBar :status="reproved" />
        <ProgressBar :status="pending" />
    </div>
    <div v-else-if="typeBar == 'circle'" class="progress-circle">
        <div class="circle-width" :style="circleStyle"></div>
    </div>
</template>

<script>
import lodash from 'lodash'
import ProgressBar from './ProgressBar.vue'
import { status as Status } from '@/services/constants/index.js'

export default {
    name: 'status-bar',
    components: {
        ProgressBar
    },
    props: {
        data: {
            required: true
        },
        hasData: {
            default: true
        },
        typeBar: {
            required: true,
            default: 'progress' || 'circle'
        }
    },
    created() {
        if (this.hasData) {
            this.mapStatus(this.data)
            this.countStatus()
        }
    },
    data() {
        return {
            dataComponent: this.data,
            status: null,
            amount: 100,
            approved: { value: 0, color: 'var(--green-400)' },
            pending: { value: 0, color: 'var(--yellow-400)' },
            reproved: { value: 0, color: 'var(--red-400)' }
        }
    },
    computed: {
        circleStyle() {
            const color =
                this.data == Status.APPROVED
                    ? this.approved.color
                    : this.data == Status.REPROVED
                    ? this.reproved.color
                    : this.pending.color

            return { backgroundColor: color }
        }
    },
    methods: {
        mapStatus(data) {
            this.status = data.map(element => {
                return { status: element.status }
            })
        },

        countStatus() {
            let status = lodash.countBy(this.status, 'status')
            let division = this.amount / this.data.length

            this.approved.value = this.getDefaultValueForStatus(
                division,
                status[Status.APPROVED]
            )
            this.reproved.value = this.getDefaultValueForStatus(
                division,
                status[Status.REPROVED]
            )
            this.pending.value = this.getDefaultValueForStatus(
                division,
                status[Status.PENDING]
            )
        },

        getDefaultValueForStatus(valueOne, valueTwo) {
            return !isNaN(valueTwo) ? valueOne * valueTwo : 0
        }
    },
    watch: {
        data: {
            handler: function(val) {
                if (this.hasData) {
                    this.mapStatus(val)
                    this.countStatus()
                }
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style scoped>
.progress {
    display: flex;
    width: 100%;
    height: 0.63rem;
    margin-bottom: 3px;
    background-color: rgb(228, 227, 227);
}

.progress-circle {
    margin: 0 auto;
    display: flex;
    width: 2.25rem;
    height: 2.25rem;
    gap: 3px;
}

.circle-width {
    margin: 0 auto;
    border-radius: 100%;
    width: 100px;
}
</style>
